export default {
  id: "categoryComparison",
  name: "",
  description: "",
  report: {
    name: "Category Comparison",
    chartType: "",
    template: "category-comparison",
    config: {
      dataType: "single",
      dataSet: "Category",
      measures: [],
      dimensions: [],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "100",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
      applyDateRangeFilter: true,
      filterDateRange: true,
    },
  },
};
